import { Icon, type IconType } from '@graftcode/design-system'

import { GRAFTCODE_ONBOARDING_GUIDE_OS, type GraftcodeOnboardingGuideOs } from './graftcode-onboarding-guide-os.const'

const GUIDE_OS_ICON: Record<GraftcodeOnboardingGuideOs, IconType> = {
  [GRAFTCODE_ONBOARDING_GUIDE_OS.windows]: Icon.DSMicrosoftBlack,
  [GRAFTCODE_ONBOARDING_GUIDE_OS.macos]: Icon.DSAppleBlack,
  [GRAFTCODE_ONBOARDING_GUIDE_OS.linux]: Icon.DSLinuxBlack,
}

export function getGuideOsIcon(os: GraftcodeOnboardingGuideOs): IconType {
  return GUIDE_OS_ICON[os]
}
